import api from "./axios";
import type { Restaurant } from "@/types";

export const getAll = () =>
  api.get<Restaurant[]>("/restaurants").then((r) => r.data);

export const getById = (id: string) =>
  api.get<Restaurant>(`/restaurants/${id}`).then((r) => r.data);

export const create = (data: {
  name: string;
  categoryId: string;
  url?: string;
  location?: string;
  imageUrl?: string;
}) => api.post<Restaurant>("/restaurants", data).then((r) => r.data);

export const update = (
  id: string,
  data: {
    name?: string;
    categoryId?: string;
    url?: string;
    location?: string;
    imageUrl?: string;
  },
) => api.patch<Restaurant>(`/restaurants/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/restaurants/${id}`).then((r) => r.data);
